import { useState } from "react";
import Grid from '@mui/material/Grid';
import CustomDialog from "../../../../components/Dialog/DiaComp";
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import DiaBook from "./PathoExplain/DiaBook";
import GetHardPathoTable from "./GetHardPathoTable";
import CVDGeneticsText from "./CVDGeneticsText";
import Stack from '@mui/material/Stack';

export default function DiaVarPathogenic() {

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
    return (
      <>
    
    <Grid container sx={{ justifyContent:'center'}}>
        <Tooltip title="Signature Variants" placement="bottom">
            <IconButton onClick={handleOpen}  >
                <AccessibilityIcon sx={{color: 'common.white', '&:hover': { color: 'primary.light'}, }}/>
            </IconButton>   
        </Tooltip>
    </Grid>

    <CustomDialog open={open} onClose={handleClose}

          title="Overview Variants classified as 'pathogenic' (clinvar)"
         
          content = {<Stack> <CVDGeneticsText /> <DiaBook /> <GetHardPathoTable /></Stack>}

        />
        
</>
)}